<template>
    <div style="position:relative;">
        <div class="paging-container" v-if="totalPage > 1 && !hidePaging">
            <span class="paging-btn" @click="firstPage"><span class="glyphicon glyphicon-fast-backward"></span></span>
            <span class="paging-btn" @click="prevPage"><span class="glyphicon glyphicon-chevron-left"></span></span>
            <span class="paging-display" @click="showPageEntry">{{page}} /{{totalPage}}</span>
            <span class="paging-btn" @click="nextPage"><span class="glyphicon glyphicon-chevron-right"></span></span>
            <span class="paging-btn" @click="lastPage"><span class="glyphicon glyphicon-fast-forward"></span></span>
        </div>
        <div>
         <slot>slot content goes here</slot>
        </div>
        <div class="paging-container" v-if="totalPage > 1 && !hidePaging">
            <span class="paging-btn" @click="firstPage"><span class="glyphicon glyphicon-fast-backward"></span></span>
            <span class="paging-btn" @click="prevPage"><span class="glyphicon glyphicon-chevron-left"></span></span>
            <span class="paging-display" @click="showPageEntry">{{page}} /{{totalPage}}</span>
            <span class="paging-btn" @click="nextPage"><span class="glyphicon glyphicon-chevron-right"></span></span>
            <span class="paging-btn" @click="lastPage"><span class="glyphicon glyphicon-fast-forward"></span></span>
        </div>
    </div>
</template>
<script>

    import SimplePaging from '../../utl/paging'

    export default {
        methods: {
            getRoutePage: function () {
                if (typeof this.$route === "undefined") {
                    return 1;
                }
                var rPage = this.$route.query.page;
                if (typeof rPage === "undefined") {
                    rPage = 1;
                };
                return rPage;
            },
            showPageEntry: function () {
                this.pageActions.showPageEntry();
            },
            firstPage: function () {
                this.pageActions.gotoFirstPage();
            },
            lastPage: function () {
                this.pageActions.gotoLastPage();
            },
            prevPage: function () {
                this.pageActions.prevPage();
            },
            nextPage: function () {
                this.pageActions.nextPage();
            },
            initPaging: function () {
                var that = this;
                var initPage = this.getRoutePage();
                that.pageActions = SimplePaging({
                    pageChange: function (page) {
                        that.$emit('pageChange', page);    
                    },
                    textChange: function (page, totalPage) {
                        that.page = page;
                        that.totalPage = totalPage;
                    },
                    currentPage: initPage,
                    pageSize: 1,
                    totalItemCount: 1
                });
                that.page = that.pageActions.getCurrentPage();
                that.totalPage = that.pageActions.getTotalPage();
            }
        },
        props: {
            pagingInfo: Object,
            hidePaging: { type: Boolean, default: false },
            ignoreWatchRoute: { type: Boolean, default: false }
        },
        data: function () {
            return {
                items: [],
                page: 1,
                totalPage:1,
                pageActions: null
            }
        },
        watch: {
            '$route'(to, from) {
                if (this.ignoreWatchRoute === true) return;
                this.page = this.getRoutePage();
            },
            'pagingInfo'() {
                this.pageActions.resetParams(this.pagingInfo.page, this.pagingInfo.pageSize, this.pagingInfo.count);
            }
        },
        mounted: function () {
            this.initPaging();
        },
        destroyed: function () {
            this.pageActions.destroy();
        }
    }
</script>
<style scoped>
.paging-container {
    padding: 10px;
    text-align: center;
    clear: both;
}

.paging-btn {
    display: inline-block;
    min-width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0 5px;
    padding: 0 15px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    color: #333;
    transition: all 0.3s ease;
}

.paging-btn:hover {
    background-color: #007bff;
    border-color: #007bff;
    color: #fff;
}

.paging-btn:active {
    background-color: #0056b3;
    border-color: #0056b3;
}

.paging-display {
    display: inline-block;
    min-width: 80px;
    height: 40px;
    line-height: 40px;
    margin: 0 5px;
    padding: 0 15px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #007bff;
    border-radius: 4px;
    background-color: #007bff;
    color: #fff;
    font-weight: bold;
}

.paging-display:hover {
    background-color: #0056b3;
    border-color: #0056b3;
}
</style>